import React, { useEffect, useState } from "react";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
import DropDownButton, { DropDownManu } from "./DropDownButton";
import CalenderDoctor from "./CalenderDoctor";
import { useNavigate } from "react-router-dom";
import {
  FetchAddAppoientmentVisit,
  FetchCptcodes,
  FetchVisitReason,
  GetappointmentsbyPut,
  GetDeliveryMode,
  GetDoctorrequest,
  GetDoctorsRequest,
  Getmyclinicpatient,
  Getserviceaddress,
} from "../../api/helper";
import { useSelector } from "react-redux";
import moment from "moment";
import CalendarView from "../AgencyFlow/AgencyScreens/CalendarView";
import ProviderCalendarView from "./ProviderCalendarView";

const Appointments = () => {
  const [view, setView] = useState("list");
  const navigate = useNavigate();
  const handleViewChange = (newView) => {
    setView(newView);
  };

  return (
    <div className="dashboard-container">
      <Sidebar />
      <div className="dashboard-content">
        <Navbar
          onClick={() => {
            navigate("/profile");
          }}
        />
        <div
          className="dashboard-cards"
          style={{ paddingLeft: 30, paddingRight: 30 }}
        >
          <div style={{ width: "100%" }}>
            <div className="tab-buttonstwo">
              <button
                className={`tab-buttontwo ${view === "list" ? "active" : ""}`}
                onClick={() => handleViewChange("list")}
              >
                Appointment List
              </button>
              <button
                className={`tab-buttontwo ${
                  view === "calendar" ? "active" : ""
                }`}
                onClick={() => handleViewChange("calendar")}
              >
                Calendar View
              </button>
            </div>
            <div style={{ width: "100%" }}>
              {view !== "list" ? <ProviderCalendarView /> : <AppointmentListView />}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Appointments;


const AppointmentListView = () => {
  const profileData = useSelector((state) => state?.cookies?.userDetails);

  const [appointments, setAppointments] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [selectedLocation, setSelectedLocation] = useState("");
  const [selectedAppointmentType, setSelectedAppointmentType] = useState("");
  const [visitstatus, setvisitstatus] = useState([]);
  const [addressData, setaddressData] = useState([]);
  const [getCptcode, setCptCode] = useState([]);
  const [appointmentType, setappointmentType] = useState([]);
  const [selectedReason, setSelectedReason] = useState("");
  const [visitReasondata, setvisitReasondata] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [cliniclist, setcliniclist] = useState([]);
  const [patientdata, setpatientdata] = useState([]);
  const [selectedAgency, setSelectedAgency] = useState("");
  const [selectedClient, setSelectedClient] = useState("");
  const [selectedCptCode, setSelectedCptCode] = useState("");

  const GetPatients = async () => {
    try {
      const data = {
        status: "approved",
        doctorId: profileData?._id,
      };
      const response = await Getmyclinicpatient(data);
      setpatientdata(response?.data.data.response);
    } catch (error) {
      console.log(error);
    }
  };

  const Getrequest = async (page) => {
    try {
      let data = {
        limit: 50,
        page: 1,
        doctorId: profileData?._id,
        status: "approved",
      };
      const response = await GetDoctorrequest(data);
      // console.log(response?.data, "doctor=-=-======");
      setcliniclist(response?.data?.data?.data);
    } catch (error) {
      console.log(error, "error=====");
    }
  };

  // console.log(cliniclist,"cliniclist=-=-=")
  const FetchAppointment = async (page = 1) => {
    const data = {
      doctorId: profileData?._id,
      // doctorId: "681bc172e3d51682ebcc2b71",
      page,
      limit: 10,
    };
    try {
      const respo = await GetappointmentsbyPut(data);
      // console.log(respo?.data?.data?.appointments,"=======>>")
      setAppointments(respo?.data?.data?.appointments);
      setTotalPages(respo?.data?.data?.totalPages || 1);
    } catch (error) {
      console.log(error, "error---");
    }
  };

  const GetCptCode = async () => {
    const response = await FetchCptcodes(`limit=1000`);
    setCptCode(response?.data?.data.data);
  };
  useEffect(() => {
    GetCptCode();
    FetchAppointment();
    GetPatients();
    Getrequest();
  }, []);
  const GetAppoientmentVisit = async (id) => {
    try {
      const response = await FetchAddAppoientmentVisit(`?id=${id}`);
      setvisitstatus(response?.data?.data);
    } catch (error) {
      console.log(error);
    }
  };

  const GetVisitReason = async (id) => {
    try {
      const response = await FetchVisitReason(`?id=${id}`);
      setvisitReasondata(response?.data?.data);
    } catch (error) {
      console.log(error);
    }
  };

  const FetchDatalist = async (id) => {
    try {
      const response = await GetDeliveryMode(`?id=${id}`);
      setappointmentType(response?.data?.data || []);
    } catch (error) {
      console.log(error);
    }
  };

  const FetchAddresslist = async (id) => {
    try {
      const response = await Getserviceaddress({ id });
      setaddressData(response?.data?.data?.data || []);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (selectedAgency) {
      GetAppoientmentVisit(selectedAgency);
      GetVisitReason(selectedAgency);
      FetchDatalist(selectedAgency);
      FetchAddresslist(selectedAgency);
    }
  }, [selectedAgency]);

  const filteredAppointments = appointments.filter((app) => {
    if (selectedLocation && app?.serviceLocationId?._id !== selectedLocation)
      return false;
    if (selectedReason && app?.visitReason?._id !== selectedReason)
      return false;
    if (selectedStatus && app?.appointmentStatus?._id !== selectedStatus)
      return false;
    if (
      selectedAppointmentType &&
      app?.deliveryMode?._id !== selectedAppointmentType
    )
      return false;

    if (startDate && endDate) {
      const appDate = new Date(app?.date).toISOString().split("T")[0];
      return appDate >= startDate && appDate <= endDate;
    }

    return true;
  });

  return (
    <div>
      <h2 style={{ textAlign: "left" }}>List View of Appointments</h2>
      <div className="filters" style={{ marginBottom: 40 }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            width: "100%",
            justifyContent: "space-between",
          }}
        >
          <div
            className="form-group_CalendarView"
            style={{
              flex: "1 1 calc(20% - 16px)",
              minWidth: "200px",
            }}
          >
            <label>Agency:</label>
            <select
              value={selectedAgency}
              onChange={(e) => setSelectedAgency(e.target.value)}
            >
              <option value="">-- Select Clients --</option>
              {cliniclist?.map((provider, index) => (
                <option key={provider._id} value={provider._id}>
                  {provider.firstName} {provider.lastName}
                </option>
              ))}
            </select>
          </div>
          <div style={{ width: 20 }} />
          <div
            className="form-group_CalendarView"
            style={{
              flex: "1 1 calc(20% - 16px)",
              minWidth: "200px",
            }}
          >
            <label>Clients:</label>
            <select
              value={selectedClient}
              onChange={(e) => setSelectedClient(e.target.value)}
            >
              <option value="">-- Select Clients --</option>
              {patientdata?.map((provider, index) => (
                <option key={provider._id} value={provider._id}>
                  {provider.firstName} {provider.lastName}
                </option>
              ))}
            </select>
          </div>
          <div style={{ width: 20 }} />
          <div
            className="form-group_CalendarView"
            style={{
              flex: "1 1 calc(20% - 16px)",
              minWidth: "200px",
            }}
          >
            <label>CPT Code:</label>
            <select
              value={selectedCptCode}
              onChange={(e) => setSelectedCptCode(e.target.value)}
            >
              <option value="">-- Select CPT Code --</option>
              {getCptcode?.map((provider, index) => (
                <option key={provider._id} value={provider._id}>
                  {provider.procCode} - {provider.procDescription}
                </option>
              ))}
            </select>
          </div>
          <div style={{ width: 20 }} />
          <div
            className="form-group_CalendarView"
            style={{
              flex: "1 1 calc(20% - 16px)",
              minWidth: "200px",
            }}
          >
            <label>Status:</label>
            <select
              value={selectedStatus}
              onChange={(e) => setSelectedStatus(e.target.value)}
            >
              <option value="">-- Select Status --</option>
              {visitstatus.map((item) => {
                return (
                  <option key={item._id} value={item._id}>
                    {item.name}
                  </option>
                );
              })}
            </select>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            width: "100%",
            marginTop: 20,
          }}
        >
          <div
            className="form-group_CalendarView"
            style={{
              flex: "1 1 calc(20% - 16px)",
              minWidth: "200px",
            }}
          >
            <label>Location Type:</label>
            <select
              value={selectedLocation}
              onChange={(e) => setSelectedLocation(e.target.value)}
            >
              <option value="">-- Select Location --</option>
              {addressData.map((item) => {
                return (
                  <option key={item._id} value={item?._id}>
                    {item?.name}
                  </option>
                );
              })}
            </select>
          </div>
          <div style={{ width: 40 }} />
          <div
            className="form-group_CalendarView"
            style={{
              flex: "1 1 calc(20% - 16px)",
              minWidth: "200px",
            }}
          >
            <label>Appointment Type:</label>
            <select
              value={selectedAppointmentType}
              onChange={(e) => setSelectedAppointmentType(e.target.value)}
            >
              <option value="">-- Select type--</option>
              {appointmentType.map((item, index) => (
                <option key={item._id} value={item._id}>
                  {item.name}
                </option>
              ))}
            </select>
          </div>

          <div style={{ width: 40 }} />

          <div
            className="form-group_CalendarView"
            style={{
              flex: "1 1 calc(20% - 16px)",
              minWidth: "200px",
            }}
          >
            <label>Appointments Reason:</label>
            <select
              value={selectedReason}
              onChange={(e) => setSelectedReason(e.target.value)}
            >
              <option value="">-- Select Reason --</option>
              {visitReasondata.map((item) => {
                return (
                  <option key={item._id} value={item._id}>
                    {item.visitReason}
                  </option>
                );
              })}
            </select>
          </div>
        </div>
      </div>
      <div className="appointments-table-container_CalendarView">
        <table className="appointments-table_CalendarView">
          <thead>
            <tr>
              <th>SessionID</th>
              <th>Client</th>
              <th>Provider</th>
              <th>Type</th>
              <th>Payment Method</th>
              <th>Duration</th>
              <th>Billing Unit</th>
              <th>SubTotal</th>
              <th>Visit Reason</th>
              <th>Date</th>
              <th>Location</th>
              <th>PA Number</th>
              <th>Ref. NPI</th>
              <th>Status</th>
              <th>Create Note</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredAppointments.length === 0 ? (
              <tr>
                <td
                  colSpan="16"
                  style={{ textAlign: "center", padding: "20px" }}
                >
                  No appointments found.
                </td>
              </tr>
            ) : (
              filteredAppointments.map((app) => (
                <tr key={app?._id}>
                  <td>{app?._id?.slice(-7)}</td>
                  <td>
                    <div
                      // onClick={() =>
                      //   navigation("/ClientEditbyagency", {
                      //     state: { data: app?.patientRequestId },
                      //   })
                      // }
                      style={{ cursor: "pointer" }}
                    >
                      {app?.patientRequestId?.firstName}{" "}
                      {app?.patientRequestId?.lastName}
                    </div>
                  </td>
                  <td>
                    <div
                      // onClick={() =>
                      //   navigation("/DoctorDetailsclinic", {
                      //     state: { data: app?.doctorRequestId },
                      //   })
                      // }
                      style={{ cursor: "pointer" }}
                    >
                      {app?.doctorRequestId?.firstName}{" "}
                      {app?.doctorRequestId?.lastName}
                    </div>
                  </td>
                  <td>{app?.deliveryMode?.name}</td>
                  <td>{app?.paymentSource}</td>
                  <td>{app?.Duration}</td>
                  <td>{"2"}</td>
                  <td>{"$150.00"}</td>
                  <td>{app?.visitReason?.visitReason}</td>
                  <td>
                    {app?.date ? moment(app.date).format("DD/MM/YYYY") : ""}
                  </td>
                  <td>{app?.serviceLocationId?.name}</td>
                  <td>
                    {app?.authorizationDetailId?.Auth
                      ? app.authorizationDetailId.Auth
                      : "Not Available"}
                  </td>
                  <td>{"999999999"}</td>

                  <td className="custom-action-td">
                    <div className="custom-dropdown">
                      <button className="custom-action-button">
                        <span
                          className="status-badge_two"
                          style={{
                            background: app?.appointmentStatus?.color,
                            color: "white",
                          }}
                        >
                          {app?.appointmentStatus?.name || "Pending"}
                        </span>
                        <i className="fas fa-ellipsis-v" />
                      </button>
                      <div className="custom-dropdown-menu">
                        <ul>
                          {visitstatus
                            .filter(
                              (statusObj) =>
                                statusObj.name.trim().toLowerCase() !==
                                (app?.appointmentStatus?.name || "")
                                  .trim()
                                  .toLowerCase()
                            )
                            .map((statusObj) => (
                              <li key={statusObj._id}>
                                <button
                                  className="custom-dropdown-item"
                                  // onClick={() =>
                                  //   UpdateStatus(app, statusObj?._id)
                                  // }
                                >
                                  {statusObj.name}
                                </button>
                              </li>
                            ))}
                        </ul>
                      </div>
                    </div>
                  </td>

                  <td className="custom-action-td">
                    <div className="custom-dropdown">
                      <button className="custom-action-button">
                        Create Note ⋮
                      </button>
                      <div className="custom-dropdown-menu">
                        <ul>
                          <li>
                            <button className="custom-dropdown-item">
                              Clinical Note
                            </button>
                          </li>
                          <li>
                            <button className="custom-dropdown-item">
                              Therapeutic Note
                            </button>
                          </li>
                          <li>
                            <button className="custom-dropdown-item">
                              Operational Note
                            </button>
                          </li>
                          <li>
                            <button className="custom-dropdown-item">
                              Observation Note
                            </button>
                          </li>
                          <li>
                            <button className="custom-dropdown-item">
                              General Note
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </td>

                  <td className="custom-action-td">
                    <div className="custom-dropdown">
                      <button className="custom-action-button">
                        Actions ⋮
                      </button>
                      <div className="custom-dropdown-menu">
                        <ul>
                          <li>
                            <button className="custom-dropdown-item">
                              Edit Appointment
                            </button>
                          </li>
                          <li>
                            <button className="custom-dropdown-item">
                              Cancel Appointment
                            </button>
                          </li>
                          <li>
                            <button className="custom-dropdown-item">
                              Send Reminder
                            </button>
                          </li>
                          <li>
                            <button className="custom-dropdown-item">
                              View Full Details
                            </button>
                          </li>
                          <li>
                            <button className="custom-dropdown-item">
                              Capture Charges
                            </button>
                          </li>
                          <li>
                            <button className="custom-dropdown-item">
                              Create Invoice
                            </button>
                          </li>
                          <li>
                            <button className="custom-dropdown-item">
                              Join Telehealth
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>

        <div className="pagination-controls_CalendarView">
          <button
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
            style={{ color: "black" }}
          >
            Previous
          </button>

          <span style={{ margin: "0 10px", marginTop: 10 }}>
            Page {currentPage} of {totalPages}
          </span>
          <button
            onClick={() =>
              setCurrentPage((prev) => Math.min(prev + 1, totalPages))
            }
            disabled={currentPage === totalPages}
            className="active"
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};
